'use client'

import React from 'react'
import { useLanguage } from '@/app/(frontend)/providers/LanguageProvider'
import { motion } from 'framer-motion'
import MapWithLeaflet from '../Common/MapWithLeaflet'

const LocationMap = () => {
  const { language } = useLanguage()
  const isArabic = language === 'ar'

  return (
    <section className="w-full md:min-h-screen bg-white flex flex-col items-center justify-center overflow-hidden my-[-2px]">
      {/* Fade-In Animation Wrapper */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        viewport={{ once: true }}
        className="w-full sm:w-[95%] md:w-[90%] lg:w-[928px] xl:w-[1250px] 2xl:w-[1650px]"
      >
        <div className="flex  flex-col xl:gap-[18px]">
          {isArabic ? (
            <>
              <h2 className=" px-3 md:px-0 text-[24px] md:text-[28px] lg:text-[32px] xl:text-[40px] font-[500] text-[#414141] font-robto mt-20 xl:mt-0 text-right md:text-center">
                خريطة الموقع
              </h2>
              <p className="text-[#666666] text-right md:text-center text-sm md:text-base xl:text-[16px] mt-2 mb-5 px-3 md:px-0 ">
                إحنا على بعد ١٢ كم من ميناء حمد و٥ كم من منطقة مسيعيد الصناعية. اضغط أدناه لفتح
                خرائط جوجل: URL إلى
                <br />
                Gmaps
              </p>
            </>
          ) : (
            <>
              <h2 className="px-3 md:px-0 text-[24px] md:text-[28px] lg:text-[32px] xl:text-[40px] font-[500] text-[#414141] font-robto mt-20 xl:mt-0 text-left md:text-center">
                Location Map
              </h2>
              <p className="text-[#666666] md:text-center px-3 md:px-0 text-[15px] md:text-base xl:text-[16px] mt-2 mb-5 max-w-[680px] mx-auto !leading-[1.1rem]">

                We&apos;re 12 km from Hamad Port and 5 km from Mesaieed Industrial Zone. Click below
                to launch Google Maps
              </p>
            </>
          )}
        </div>
      </motion.div>

      {/* Map Section */}
      <div className="w-full px-0 mt-6">
        {/* <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19804.02172145533!2d-0.21668225378498686!3d51.54075967856396!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876109efb0c3d71%3A0x4f1ad9a2b88ef9e7!2sCricklewood%2C%20London%2C%20UK!5e0!3m2!1sen!2s!4v1718182281740!5m2!1sen!2s"
          width="100%"
          height="450"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="w-full xl:h-[698px]"
        ></iframe> */}

        <div className="w-full h-[698px] xl:h-[698px] rounded-md overflow-hidden border">
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.6805206905224!2d51.45636789999999!3d25.044913899999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e442df643000b4d%3A0xeca41d5950b57082!2sContainer%20City%20Qatar!5e0!3m2!1sen!2sin!4v1754311524042!5m2!1sen!2sin"
    className="w-full h-full border-0"
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  />
</div>
      </div>

      {/* Footer Note Section */}
      {/* <div className="w-[90%] xl:w-full">
        {isArabic ? (
          <p className="text-[#666666] text-[15px] xl:text-[15px] font-[400] mt-5 md:mt-[30px] xl:mt-[48px] max-w-[620px]  xl:mr-20">
            دخول للمقطورات ومواقف للزوار متوفرة. يمكن توفير تصريح أمني لزيارة المنشآت <br />
            الجمركية عند الطلب.
          </p>
        ) : (
          <p className="text-[#666666] text-[15px] xl:text-[15px] font-[400] mt-5 md:mt-[30px] xl:mt-[48px] max-w-[620px]  xl:ml-20">
            Trailer access & visitor parking available. Security clearance for bonded facility
            visits is available on request.
          </p>
        )}
      </div> */}
    </section>
  )
}

export default LocationMap
